import type { AssistantCitation, ScopedThreadRef } from "@cmmd-forge/contracts";
import {
  serializeAssistantCitation,
  parseAssistantCitationHref,
  formatAssistantCitationHref,
} from "@cmmd-forge/shared/assistantCitations";
import { useComposerDraftStore } from "../../composerDraftStore";

export function insertAssistantCitationInDraft(
  threadRef: ScopedThreadRef,
  citation: AssistantCitation,
): boolean {
  if (!parseAssistantCitationHref(formatAssistantCitationHref(citation))) return false;
  const store = useComposerDraftStore.getState();
  const prompt = store.getComposerDraft(threadRef)?.prompt ?? "";
  const separator = prompt.length > 0 && !prompt.endsWith("\n") ? "\n" : "";
  store.setPrompt(threadRef, `${prompt}${separator}${serializeAssistantCitation(citation)} `);
  return true;
}
